<template>
  <div style="height:100vh;">
    啊哈哈哈哈



<el-dialog
  title="提示"
  :visible="dialog"
  width="30%"
  :before-close="handleClose">
  <h3>当前系统暂不支持该地域登录</h3>

</el-dialog>
</div>
</template>

<script>
import vueQr from "vue-qr";
import secret from "@/publicFunction/secret";
import logoSrc from "../assets/img/login/project-logo.png";
import getInfo from "@/publicFunction/getComputerInfo.js";
import axios from 'axios'
import {v4 as uuidv4} from 'uuid'
export default {
  name: "",
  components: {
    vueQr
  },
  props: {},
  data() {
    return {
      showLoading:true,
      vCode: "",
      loginData: {
        loginId: "",
        userPwd: "",
        uKey: "",
        vCode: ""
      },
      loginState: 0,
      logoSrc,
      phoneData: {
        phone: "",
        code: ""
      },
      QRInfo: {
        code: "",
        type: 1 //方便手机端区分是PC端扫码登录
      },
      verificationState: false,
      verificationText: "获取验证码",
      time: 60,
      idMessageText: "", //账号登录提示
      phoneMessageText: "", //手机号登录提示
      QRLoading: false,
      QRState: 0, //二维码状态
      QRTime: null,
      computerInfo: {
        clientType: 2,
        deviceModel: "",
        deviceSystemVersion: "",
        uniqueDeviceIdentifier: ""
      },
      dialog:false
    };
  },
  watch: {},
  computed: {
    schoolBidDataVersion() {
      return this.$store.state.schoolBidDataVersion;
    },
    eduBidDataVersion() {
      return this.$store.state.eduBidDataVersion;
    }
  },

  methods: {
    handleClose(){

    },
    // 登录
    async userLogin() {
      if (this.loginData.loginId == "") {
        this.$message("请输入账号！");
        return;
      }
      if (this.loginData.userPwd == "") {
        this.$message("请输入密码！");
        return;
      }
      if (this.loginData.vCode == "") {
        this.$message("请输入图片验证码！");
        return;
      }
      // console.log(this.loginData)
      let requestData = Object.assign(this.computerInfo, this.loginData);
      // let userInfo = this.loginData.loginId+ '&' +this.loginData.userPwd
      // let encryptData = secret.Encrypt(userInfo);
      // console.log(encryptData,'--------加密后')
      //  	let decryptData = secret.Decrypt(encryptData)
      // console.log(decryptData,'---------解密后')
      let res = await this.$Http.userLogin(requestData, true);
      // console.log(res);
      if (res.code == 200) {
        this.dataStorage(res.data);
      } else if (res.code == 1012) {
        this.$message(res.messsage);
        this.loginSelect(1);
      }else if(res.code == 1009){
        this.$alert(res.messsage, '提示', {
          center: true,
          confirmButtonText: '关闭',
          dangerouslyUseHTMLString:true,
        });
        setTimeout(() => {
          sessionStorage.clear();
        }, 50);
        this.getCaptureCode();
      } else {
        this.$message({
          message: res.messsage,
          duration: 3600,
          type: "error"
        });
        this.getCaptureCode();
      }
    },

    // 获取教育局信息
    async getEduInfo() {
      var requestData = {
        eduId: this.$store.getters.getUserInfo.eduId
      };
      let res = await this.$Http.getEduInfo(requestData);
      if (res.code == 200) {
        var eduInfo = res.data;
        sessionStorage.setItem("eduInfo", JSON.stringify(eduInfo));
        if (sessionStorage.getItem("eduInfo")) {
          this.$store.commit(
            "updateEduInfo",
            sessionStorage.getItem("eduInfo")
          );
          // console.log(this.$store.getters.getEduData);

          this.$nextTick(() => {
            // this.$router.push('/group_basic_info')
            if (eduInfo.eduBuresuType == -1) {
              // 高校版本
              this.$Common.pageJump("/newUniversityBigData", 2, 0);
            } else if (eduInfo.eduBuresuType == -2) {
              // 后勤总公司
              this.$Common.pageJump("/l_user_data", 2, 0);
            } else {
              // 教育局版本
              this.$Common.getNoticesNumber(2);
              if (eduInfo.eduId == 135) {
                this.$Common.pageJump("/sanMen", 0);
              } else {
                this.$Common.pageJump(
                  "/eduSecuritySituation_" + this.eduBidDataVersion,
                  2,
                  0
                );
              }
            }
          });
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    loginSelect(num) {
      if(this.dialog) return
      if(num===2){
        window.open(`https://open.weixin.qq.com/connect/qrconnect?appid=wxd0fca93d9f277fb8&redirect_uri=https://school.zzsasoft.com/wxScanLogin&response_type=code&scope=snsapi_login&state=${uuidv4()}`, '_blank');

      }else{
        this.loginState = num || 0;
        if (num == 0) {
          //   账号密码登录
          this.phoneMessageText = "";
          clearTimeout(this.QRTime);
          // this.loginData = {
          //   loginId: "",
          //   userPwd: "",
          //   uKey: "",
          //   vCode: ""
          // };
          this.getCaptureCode();
        } else if (num == 1) {
          // 手机号登录
          this.phoneData = {
            phone: "",
            code: ""
          };
          // this.getCaptureCode();
          clearTimeout(this.QRTime);
        } else {
          // 扫码登录
          let self = this;
          this.getUUID();
        }
      }

    },
    getVerificationCode() {
      if (this.phoneData.phone == "") {
        this.$message.warning("请输入手机号");
      } else {
        let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!myreg.test(this.phoneData.phone)) {
          this.phoneData.phone = "";
          this.$message.warning("请输入正确手机号");
        } else {
          this.getVerificationCodeData();
        }
      }
    },
    //发送手机验证码倒计时
    timer() {
      if (this.time > 0) {
        this.verificationState = true;
        this.time--;
        this.verificationText = this.time + "秒";
        setTimeout(this.timer, 1000);
        this.$refs.verificationRef.className = "un-click-button";
      } else {
        this.verificationText = "发送验证码";
        this.verificationState = false;
        this.$refs.verificationRef.className = "click-button";
      }
    },
    async getVerificationCodeData() {
      let req = { phone: this.phoneData.phone, type: 1 };
      let res = await this.$Http.getVerifyCode(req, true);
      if (res.code == 200) {
        this.phoneMessageText = "";
        this.time = 60;
        this.timer();
      } else {
        this.phoneMessageText = res.messsage || "";
      }
    },
    // 验证码登录
    async verificationLogin() {
      let req = Object.assign(this.computerInfo, this.phoneData, {
        loginType: 1
      });
      let res = await this.$Http.verifyCodeLogin(req, true);
      if (res.code == 200) {
        this.dataStorage(res.data);
      } else {
        this.$message({
          message: res.messsage || "登陆失败",
          type: "error"
        });
      }
    },
    forgetPassword() {
      let routeUrl = this.$router.resolve({
        path: "forget_password"
      });
      window.open(routeUrl.href, "_blank");
    },
     async getUUID() {
      this.QRLoading = true;
      let res = await this.$Http.getLoginUUID();
      if (res.code == 200) {
        this.phoneMessageText = "";
        this.QRInfo.code = res.data || "";
        this.QRState = 0;
      } else {
        this.phoneMessageText = "";
        this.QRInfo.code = "";
      }
      this.QRLoading = false;
      let self = this;
      this.QRTime = setInterval(function() {
        self.getMonitoring();
      }, 1000);
    },
    refreshQR() {
      this.getUUID();
    },
    async getMonitoring() {
      let res = await this.$Http.getMonitoringStatus({
        uuid: this.QRInfo.code
      });
      if (res.code == 200) {
        this.QRState = res.data.status || 0;
        if (this.QRState == 1 || this.QRState == 4 || this.QRState == 5) {
          //   二维码失效   取消登录   账号异常
          clearTimeout(this.QRTime);
        }
        if (this.QRState == 3) {
          // 确认登录
          clearTimeout(this.QRTime);
          this.dataStorage(res.data.user);
        }
      } else {
        clearTimeout(this.QRTime);
        this.QRState = 1;
      }
    },
    dataStorage(data) {
      var userInfo = {
        userId: data.userId,
        userName: data.userName,
        userPhone: data.userPhone,
        email: data.email,
        token: data.token,
        userIdNumber: data.userIdNumber,
        loginId: data.loginId,
        headPortrait: data.headPortrait,
        eduId: data.eduId,
        eduBuresuType: data.eduBuresuType,
        logisticsId: data.logisticsId,
        schoolId: data.schoolId,
        roleId: data.roleId
      };
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      var newUserInfo = sessionStorage.getItem("userInfo");
      this.$store.commit("updateUserInfo", newUserInfo);

      sessionStorage.setItem("schoolId", data.schoolId);
      this.$store.commit("updateSchoolId", sessionStorage.getItem("schoolId"));
      // this.getUnreadMessages(userInfo.userId);

      if (userInfo.eduId == 0) {
        this.$Common.getNoticesNumber(1);
        this.$router.push("/schoolIndex_" + this.schoolBidDataVersion);
      } else {
        this.getEduInfo();
      }
    },
    async getUnreadMessages(userId) {
      let res = await this.$Http.getUnreadMessages({
        userId: userId
      });
      if (res.code == 200) {
        this.$store.commit("unreadMessages", res.data.number || 0);
      } else {
        this.$store.commit("unreadMessages", 0);
      }
    },
    getFinger() {
      const Fingerprint2 = require("fingerprintjs2");
      // console.log(Fingerprint2)
      return new Promise((resolve) => {
        if (window.requestIdleCallback) {
          requestIdleCallback(function() {
            Fingerprint2.getV18(function(result) {
              resolve(result);
              // console.log(result,11)
            });
          });
        } else {
          setTimeout(function() {
            Fingerprint2.getV18(function(result) {
              resolve(result);
              // console.log(result,22)
            });
          }, 500);
        }
      });
    },
    async getComputerInfo() {
      let info = getInfo.getInfo();
      // console.log(info);
      const finger = await this.getFinger();
      // console.log('指纹: ', finger, finger.length) // 7592820773a07e4653af2b2515c83efd
      this.computerInfo = {
        clientType: 2,
        deviceModel: info.system,
        deviceSystemVersion: info.osVersion,
        uniqueDeviceIdentifier: finger
      };
      // console.log(finger);
      // this.getCaptureCode();
    },

    getUrlParam(theUrl) {
      /*获取地址，若有传参则为参数，否则为当前页面地址*/
      var thisUrl = theUrl || location.href || "";
      // if()
      /*创建一个用于存储参数的对象*/
      var paramObj = new Object();
      /*若存在‘？’，说明地址携带参数，否则没带参数*/
      if (thisUrl.indexOf("?") != -1) {
        /*截取地址中从‘？’下一位开始的字符串，即参数字段*/
        var str = thisUrl.substr(thisUrl.indexOf("?") + 1);

        var strs = str.split("&");
        /*参数存储于对象之中*/
        for (var i = 0; i < strs.length; i++) {
          /*decodeURIComponent() 对编码后的 URI 进行解码*/
          paramObj[strs[i].split("=")[0]] = decodeURIComponent(
            strs[i].split("=")[1]
          );
        }
      }
      // console.log(paramObj)
      // return paramObj;
      let obj = JSON.stringify(paramObj);
      // console.log('paramObj.iflyssost',strs[0],'strs',strs,paramObj)
      if (obj != "{}") {
        // this.showLoading=true
        if('ifuseriflyssost' == strs[0]){
          this.authorizeLogin(paramObj.iflyssost);
        }else{
          this.xyeAuthorizeLogin(paramObj);
        }
      }
    },
    async getCaptureCode() {
      let req = {};
      let res = await this.$Http.getCaptureCode(req, true);
      // console.log(res);
      if (res.code == 200) {
        // console.log(res.data)
        this.vCode = res.data.verificationCode;
        this.loginData.uKey = res.data.code;
        // this.phoneData.uKey = res.data.code;
      } else {
        if(res.code == 1008){
          this.$alert(res.messsage, '系统升级中', {
            center: true,
            confirmButtonText: '关闭',
            dangerouslyUseHTMLString:true,
          });
          setTimeout(() => {
            sessionStorage.clear();
          }, 50);
        }else{
          this.$message({
            message: res.messsage,
            type: "error"
          });
        }

      }
    },
    // 金水区科大讯飞授权登录
    async authorizeLogin(str) {
      let req = {
        ticket: str
      };
      let res = await this.$Http.authorizeLogin(req, true);
      // console.log(res);
      if (res.code == 200) {
        this.dataStorage(res.data);
      } else if (res.code == 1012) {
        this.$message(res.messsage);
        this.loginSelect(1);
      } else {
        this.showLoading=false
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // ticket单点登录
    async xyeAuthorizeLogin(str) {
      console.log(str)
      let req = {
        ticket: str.ticket,
        platformCode:str.platformCode

      };
      let res = await this.$Http.xyeAuthorizeLogin(req, false);
      // console.log(res);
      if (res.code == 200) {
        this.dataStorage(res.data);
      } else if (res.code == 1012) {
        this.$message(res.messsage);
        this.loginSelect(1);
      } else {
        this.showLoading=false

        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    
    // 获取服务器时间
    async getServerTime() {
    // let req = {
    //   schoolId: this.$store.state.schoolId
    // };
    let res = await this.$Http.getServerTime();
    if (res.code == 200) {
      let serverTime = res.data;
      sessionStorage.setItem("serverTime", serverTime);
      let localTime1 = parseInt(Date.parse(new Date()) / 1000);
      sessionStorage.setItem("localTime1", localTime1);
      // this.getCaptureCode();
    } else {
      console.log("获取服务器时间错误");
    }
  },
  async getIp(){
      let province=['Henan']
  let data =  await axios.get('http://ip-api.com/json/')
   let regionName = data.data.regionName
      //  if(regionName&&!province.includes(regionName)){
      //       this.dialog=true
      //  }
  }
  },
  created() {
    this.getServerTime();
    this.getComputerInfo();
    this.getIp()
    // 获取code值
    console.log(this.$route.query,'========query');
    // this.getUrlParam(window.location.href);
    // this.getCaptureCode();
  },
  mounted() {
    if(this.$route.query){
      // console.log(JSON.stringify(this.$route.query))
      if (JSON.stringify(this.$route.query) != '{}') {
        this.getUrlParam(window.location.href);
      }else{
        this.showLoading=false
      }
      if (this.$route.query.code) {
        let decryptData = secret.Decrypt(this.$route.query.code);
        let codeArr = decryptData.split("&");
        this.loginData.loginId = codeArr[0];
        this.loginData.userPwd = codeArr[1];
        this.userLogin();
      }
    }
    
    this.getCaptureCode();

  }
};
</script>

<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}

.login-bg {
  width: 100vw;
  height: 100vh;
  background: url("~@/assets/img/login/login-bg.gif") center top no-repeat;
  background-size: cover;
  position: relative;
  input:-webkit-autofill {
    color: #ffffff;
    background: transparent !important;
    box-shadow: inset 0px 1px 9px 0px #4955ac;
    border: none;
  }
}

.intro {
  width: 300px;
  position: absolute;
  top: 14.8%;
  .intro-title {
    padding-top:45px;
     font-size:24px;
    // font-family: PingFangSC-Medium, PingFang SC;
    // font-weight: 600;
    // color: rgba(255, 255, 255, 0.9);
    letter-spacing:3px;
    // position: relative;
    height: 23px;
    color: #ffffff;
    // width: 153px;
    // background: url("~@/assets/img/login/intro-title.png") center center
    //   no-repeat;
    // background-size: 100% 100%;
    // &:after {
    //   display: block;
    //   content: "";
    //   width: 140px;
    //   height: 2px;
    //   background: rgba(255, 255, 255, 0.9);
    //   position: absolute;
    //   left: 5px;
    //   top: 38px;
    // }
    //color: rgb(84, 210, 233);
    color:white;
  }

  .intro-content-one {
    margin-top: 20px;
    height: 17px;
    width: 297px;
    background: url("~@/assets/img/login/intro-content-one.png") center center
      no-repeat;
    background-size: 100% 100%;
  }
  .intro-content-two {
    margin-top: 16px;
    height: 17px;
    width: 138px;
    background: url("~@/assets/img/login/intro-content-two.png") center center
      no-repeat;
    background-size: 100% 100%;
  }
}

.login-form {
  width: 380px;
  height: 370px;
  position: absolute;
  top: 24.2%;
  // top: 195px;
  /* right: 348px; */
  box-shadow: inset 0px 1px 38px 0px rgba(65, 77, 161, 0.5);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  &.capture {
    height: 450px;
  }
}

.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  position: fixed;
  left: 0;
  bottom: 0;
  color: #fff;
  .sel {
    padding-left: 5px;
    color: #fff;
  }
}

@media screen and (min-width: 1684px) {
  .login-form {
    right: 348px;
  }
  .intro {
    top: 14.6%;
    left: 310px;
    .intro-title {
      font-size: 24px;
      margin-bottom: 10px;
      margin-left: -40%;
      color: #ffffff;
    }

    .intro-tip {
      font-size: 40px;
      line-height: 29px;
      letter-spacing: 2px;
    }
  }
}

@media screen and (max-width: 1683px) {
  .login-form {
    right: 48px;
  }
  .intro {
    position: absolute;
    top: 12.4%;
    left: 100px;
    .intro-title {
      font-size: 24px;
      margin-bottom: 10px;
      color: #ffffff;
    }

    .intro-tip {
      font-size: 16px;
      line-height: 26px;
      letter-spacing: 2px;
    }
  }
}

.title {
  padding-top: 24px;
  text-align: center;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 33px;
}

.name,
.password {
  margin: 32px auto 0 auto;
  width: 319px;
  height: 50px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.name-icon {
  display: inline-block;
  width: 20px;
  height: 23px;
  background: url("~@/assets/img/login/login-name-icon.png") center center
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 14px;
  top: 14px;
}

.password-icon {
  display: inline-block;
  width: 20px;
  height: 23px;
  background: url("~@/assets/img/login/login-password-icon.png") center center
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 14px;
  top: 14px;
}
.capture-icon {
  display: inline-block;
  width: 23px;
  height: 23px;
  background: url("~@/assets/img/login/login-capture-icon.png") center center
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 14px;
  top: 14px;
}
.phone-icon {
  display: inline-block;
  width: 20px;
  height: 23px;
  background: url("~@/assets/img/login/login-phone-icon.png") center center
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 14px;
  top: 14px;
}
.verification-icon {
  display: inline-block;
  width: 20px;
  height: 23px;
  background: url("~@/assets/img/login/login-verification-icon.png") center
    center no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 14px;
  top: 14px;
}
.name input,
.password input {
  width: 100%;
  height: 100%;
  box-shadow: inset 0px 1px 9px 0px #4955ac;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.42);
  background: transparent;
  padding-left: 52px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  &:-internal-autofill-selected {
    background: transparent !important;
    box-shadow: inset 0px 1px 9px 0px #4955ac;
  }
  &:-webkit-autofill {
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.42);
    -webkit-text-fill-color: #ededed !important;
    -webkit-box-shadow: 0px 1px 9px 0px #4955ac inset !important;
    background-color: transparent;
    background-image: none;
    transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
  }
}
.password input {
  padding-right: 116px;
}
.click-button {
  position: absolute;
  height: 35px;
  width: 100px;
  right: 10px;
  color: #ffffff;
  background: url("~@/assets/img/login/login-button-bg.png") center center
    no-repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  border: none; // 去掉边框
  outline: none; // 去掉点击按钮后的边框
  transition: transform 0.3s;
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
  }
}
.un-click-button {
  position: absolute;
  height: 35px;
  width: 100px;
  right: 10px;
  color: #000;
  opacity: 0.8;
  font-weight: 500;
  background: url("~@/assets/img/login/count-down-bg.png") center center
    no-repeat;
  background-size: 100% 100%;
  border: none; // 去掉边框
  outline: none; // 去掉点击按钮后的边框
  cursor: pointer;
  border-radius: 4px;
}
.password-button {
  position: absolute;
  height: 35px;
  width: 100px;
  right: 10px;
  color: #b3bdff;
  background-color: transparent;
  border: none; // 去掉边框
  outline: none; // 去掉点击按钮后的边框
  border-radius: 4px;
  transition: transform 0.3s;
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
  }
}
input:focus {
  outline: none;
}

.button {
  text-align: center;
}

.el-button {
  width: 157px;
  height: 45px;
  background: rgba(8, 161, 253, 1);
  border-radius: 8px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  border: 1px solid rgba(220, 223, 230, 0.2);
}
.login-select {
  margin-top: 20px;
  width: 100%;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  opacity: 0.8;
  .login-select-left {
    width: 50%;
    text-align: center;
    transition: transform 0.3s;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
      color: rgb(84, 210, 233);
    }
  }
  .login-select-right {
    width: 50%;
    text-align: center;
    transition: transform 0.3s;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
      color: rgb(84, 210, 233);
    }
  }
}
.QR {
  height: 249px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.QRPastDue {
  width: 200px;
  height: 200px;
  //   border: 0.5px solid #f5f5f5;
  background-color: #1a2149;
  box-shadow: inset 0px 1px 38px 0px rgba(65, 77, 161, 0.5);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  //   已过期
  .PastDueIcon {
    margin: 20px 65px 10px 65px;
    width: 70px;
    height: 70px;
    background: url("~@/assets/img/login/login-lose-efficacy.png") center center
      no-repeat;
    background-size: 100% 100%;
  }
  //   已扫码
  .scanIcon {
    margin: 20px 65px 10px 65px;
    width: 70px;
    height: 70px;
    background: url("~@/assets/img/login/login-succeed.gif") center center
      no-repeat;
    background-size: 100% 100%;
  }
  //   已取消
  .loseEfficacyIcon {
    margin: 20px 65px 10px 65px;
    width: 70px;
    height: 70px;
    background: url("~@/assets/img/login/login-lose-efficacy.png") center center
      no-repeat;
    background-size: 100% 100%;
  }
  //   确认登录
  .succeedIcon {
    margin: 20px 65px 10px 65px;
    width: 70px;
    height: 70px;
  }
  //   账号异常
  .abnormalIcon {
    margin: 20px 65px 10px 65px;
    width: 70px;
    height: 70px;
    background: url("~@/assets/img/login/login-abnormal.png") center center
      no-repeat;
    background-size: 100% 100%;
  }
  .QRState {
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    font-size: 16px;
  }
  .QRContent {
    margin-top: 10px;
    height: 30px;
    font-size: 14px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: rgba(134, 218, 252, 0.6);
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(134, 218, 252, 0.6);
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(134, 218, 252, 0.6);
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: rgba(134, 218, 252, 0.6);
}
</style>
